/** When your routing table is too long, you can split it into small modules**/
/* Layout */
import Layout from '@/layout'

/* Router Modules */
const orderRouter = {
  path: '/order',
  component: Layout,
  name: 'order',
  redirect: '/order/list',
  hidden: true,
  meta: {
    title: '个人中心'
  },
  children: [
    {
      path: 'list',
      component: () => import('@/views/order/list'),
      name: 'OrderList',
      meta: { title: '清单提交记录', affix: true, projectId: 2 }
    },
    {
      path: 'detail/:id(\\d+)',
      component: () => import('@/views/order/detail'),
      name: 'OrderDetail',
      meta: { title: '订单详情', noCache: true },
      hidden: true
    }
    /* {
      path: '/order/detail',
      component: () => import('@/views/order/detail'),
      name: 'orderDetail',
      hidden: true,
      meta: { title: '品牌形象', affix: true, projectId: 2, guidePath: true, jumpPath: '/order' }
    } */
  ]
}

export default orderRouter
